<template>
	<v-card>
		<v-card-title>
			<div class="d-flex">
				<span class="headline">مشخصات مشتری</span>
				<MemberAuthorizationManager v-if="localData.id" area="admin" :member="localData" />
			</div>
			<v-spacer />
			<v-btn @click="$emit('close')" icon>
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-card-title>
		<v-card-text>
			<v-form ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
				<v-container>
					<v-row>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="userCode" v-model="localData.userCode" label="کد مشتری" maxlength="50" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12" md="4" class="py-0">
						</v-col>
						<v-col cols="12" md="4" class="py-0">
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="4">
							<v-text-field ref="username" v-model="localData.userName" label="نام کاربری" hint="نام کاربری به صورت خودکار پر می شود" persistent-hint disabled />
						</v-col>
						<v-col cols="12" md="4">
							<div v-if="!selectAgentMode" class="d-flex justify-start align-center">
								<v-text-field ref="agent" v-model="localData.agentName" label="نماینده" disabled />
								<v-btn x-small @click="loadAgents" :loading="loadingAgents" color="secondary">انتخاب</v-btn>
							</div>
							<v-select v-else v-model="localData.agentId" clearable :items="agents" label="نماینده" single-line :error-messages="errorMessages" item-text="businessName" item-value="id" />
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field v-if="localData.id !== 0" ref="amrketer" v-model="localData.marketerName" label="بازاریاب" disabled />
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="firstName" v-model="localData.firstName" label="نام*" :error-messages="errorMessages" :rules="[() => !!localData.firstName || 'نام را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="lastName" v-model="localData.lastName" label="نام خانوادگی*" :error-messages="errorMessages" :rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="fatherName" v-model="localData.fatherName" label="نام پدر*" :error-messages="errorMessages" :rules="[() => !!localData.fatherName || 'نام پدر را وارد کنید']" required />
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" :md="settings.otpRequiredInManualMemberRegistration ? 3 : 4" class="py-0">
							<v-text-field ref="nationalCode" v-model="localData.nationalCode" maxlength="10" label="کد ملی*" :error-messages="errorMessages" :rules="[() => !!localData.nationalCode || 'کد ملی را وارد کنید']" required />
						</v-col>
						<v-col cols="12" md="6" class="py-0" v-if="settings.otpRequiredInManualMemberRegistration">
							<v-card color="#eee" class="px-2 d-flex" elevation="0">
								<v-text-field ref="mobile" v-model="localData.mobile" maxlength="11" label="موبایل*" />
								<div v-if="!localData.mobileVerified || initMobile !== localData.mobile" class="d-flex px-2 align-center" style="width:170px">
									<v-text-field v-model="localData.mobileOtp" maxlength="5" label="کد تایید" :rules="[() => !!localData.mobileOtp || 'الزامی']" required />
									<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP" :loading="optLoading"><small>ارسال کد</small></v-btn>
									<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
								</div>
								<div class="px-2 align-center d-flex" v-else>
									<v-icon small color="success">mdi-check-circle</v-icon>
									<small class="success--text">تایید شده</small>
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="4" class="py-0" v-else>
							<v-text-field ref="mobile" v-model="localData.mobile" maxlength="11" label="موبایل*" />
						</v-col>
						<v-col cols="12" :md="settings.otpRequiredInManualMemberRegistration ? 3 : 4" class="py-0">
							<v-text-field ref="phone" v-model="localData.phone" maxlength="20" label="تلفن ثابت" />
						</v-col>

					</v-row>
					<v-row>
						<v-col cols="12" md="4" class="pt-2">
							<div>
								<div>تاریخ عضویت</div>
								<date-picker ref="regDate2" v-model="localData.regDate2" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" clearable :rules="[() => localData.regDate2 === '' || 'تاریخ عضویت را به صورت صحیح وارد کنید']" />
								<div class="red--text">
									{{ datePickerValidatioin }}
								</div>
							</div>
						</v-col>
						<v-col cols="12" md="4" class="pt-2">
							<div>
								<div>تاریخ تولد</div>
								<date-picker ref="birthdate" v-model="localData.birthDate" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" clearable />
								<div class="red--text">
									{{ birthDatePickerValidatioin }}
								</div>
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="4" class="pt-2">
							<v-text-field class="left-input" v-model="localData.email" :rules="[(val) => !val || (!!val && isEmailValid()) || 'فرمت ایمیل صحیح نمی باشد']" :error-messages="errorMessages" :type="'text'" label="ایمیل" />
						</v-col>
						<v-col cols="12" md="4">
							<v-text-field class="left-input" v-model="localData.password" persistent-hint :hint="localData.id !== 0 ? 'در صورت خالی بودن، پسورد تغییر نخواهد کرد' : 'حداقل 8 کاراکتر (در صورت خالی بودن، کد ملی به عنوان کلمه عبور قرار می گیرد)'" :rules="[(val) => !val || (!!val && val.length >= 8) || 'حداقل 8 کاراکتر']" :error-messages="errorMessages" :type="'text'" label="کلمه عبور*" />
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="city" v-model="localData.city" label="شهر*" :rules="[() => !!localData.city || 'شهر را وارد کنید']" />
						</v-col>
						<v-col cols="12" md="6" class="py-0">
							<v-text-field ref="address" v-model="localData.address" label="آدرس*" :rules="[() => !!localData.address || 'آدرس را وارد کنید']" />
						</v-col>
						<v-col cols="12" md="2" class="py-0">
							<v-text-field ref="postalCode" v-model="localData.postalCode" maxlength="10" label="کد پستی*" :error-messages="errorMessages" :rules="[() => !!localData.postalCode || 'کد پستی را وارد کنید']" required />
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="12" class="py-0">
							<div style="border-radius: 5px;background:#eee;padding: 10px;">
								<div class="text-center secondary--text mb-2">شماره حساب ها</div>
								<v-card v-for="(item, index) in bankAccounts" :key="index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
									<v-row>
										<v-col cols="12" md="5" class="py-0 my-0">
											<v-text-field v-model="item.accountNumber" label="شماره کارت/حساب/شبا*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره حساب را وارد کنید']" required />
										</v-col>
										<v-col cols="12" md="3" class="py-0 my-0">
											<v-text-field v-model="item.bank" label="بانک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" required />
										</v-col>
										<v-col cols="12" md="3" class="py-0 my-0">
											<v-text-field v-model="item.branch" label="شعبه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شعبه را وارد کنید']" required />
										</v-col>
										<v-col cols="1" md="1" class="my-0 py-0 d-flex flex-column justify-center">
											<v-btn @click="removeBankAccount(item, index)" class="" x-small icon dark color="pink" title="حذف">
												<v-icon dark>
													mdi-trash-can-outline
												</v-icon>
											</v-btn>
										</v-col>
									</v-row>
								</v-card>
								<div class="text-center mt-5">
									<v-btn class="mx-auto" color="secondary" dark @click="addBankAccount" small>
										<v-icon dark>
											mdi-plus-circle-outline
										</v-icon>
										شماره حساب جدید
									</v-btn>
								</div>
							</div>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<h2>معرف 1</h2>
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="familiar1FirstName" v-model="localData.familiar1FirstName" label="نام" maxlength="50" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="familiar1LastName" v-model="localData.familiar1LastName" label="نام خانوادگی" maxlength="50" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="familiar1Mobile" v-model="localData.familiar1Mobile" label="شماره تماس" maxlength="20" :error-messages="errorMessages" />
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<h2>معرف 2</h2>
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="familiar2FirstName" v-model="localData.familiar2FirstName" label="نام" maxlength="50" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="familiar2LastName" v-model="localData.familiar2LastName" label="نام خانوادگی" maxlength="50" :error-messages="errorMessages" />
						</v-col>
						<v-col cols="12" md="4" class="py-0">
							<v-text-field ref="familiar2Mobile" v-model="localData.familiar2Mobile" label="شماره تماس" maxlength="20" :error-messages="errorMessages" />
						</v-col>
					</v-row>

					<small>*فیلدهای ستاره دار ضروری هستند.</small>

				</v-container>
			</v-form>
		</v-card-text>

		<v-divider></v-divider>

		<v-card-actions class="modify-member-actions flex-column flex-md-row flex-wrap align-stretch pa-2 pa-sm-3">
			<div class="modify-member-actions__main flex-grow-1">
				<div class="modify-member-actions__toolbar d-flex flex-wrap align-center">
					<v-btn v-if="checkActivePart('thirdParty')" class="ma-1" fab dark small outlined color="pink" @click="() => { dialogThirdParty = true }" title="ارتباط با دیگر نرم افزار ها">
						<v-icon dark>
							mdi-apache-kafka
						</v-icon>
					</v-btn>
					<v-btn v-if="checkActivePart('inquiry') && localData.id != 0" class="ma-1" dark outlined color="pink" small @click="() => { inquiriesDialog = true }" title="استعلام ها">
						استعلام ها
					</v-btn>
					<v-btn v-if="localData.id !== 0" class="ma-1" color="secondary" dark small @click="showIranValidity">
						مشاهده اعتبارسنجی
					</v-btn>
				</div>
				<div v-if="localData.id !== 0" class="modify-member-actions__meta grey--text">
					<div class="modify-member-actions__wallet d-flex flex-wrap align-center">
						<v-icon v-if="localData.walletIsLock" color="red" small class="ml-1">mdi-lock</v-icon>
						<small class="ml-1">اعتبار کیف پول: {{ String(localData.credit).toPriceFormat() }} تومان</small>
						<a @click="manualWithdrawCredit" class="modify-member-actions__link">(واریز و برداشت)</a>
						<a @click="creditChargeTransactions" class="modify-member-actions__link">(مشاهده تراکنش ها)</a>
						<a @click="manageWalletLock" class="modify-member-actions__link">
							{{ localData.walletIsLock ? '(فعال کردن کیف پول)' : '(قفل کردن کیف پول)' }}
						</a>
					</div>
					<div class="modify-member-actions__details d-flex flex-wrap align-center">
						<div class="d-flex align-center flex-wrap ma-1">
							<small>پیامک ها:</small>
							<app-sms-detail :data="localData.appSmsList || []" :entityId="String(localData.id)" category="member" />
						</div>
						<div class="d-flex align-center flex-wrap ma-1">
							<small>وضعیت خوش حسابی:</small>
							<ReliabilityManager :member="localData" style="cursor:pointer" />
						</div>
						<div class="d-flex align-center flex-wrap ma-1">
							<small class="mr-2" @click="dialogThirdPersonAssurance = true">تعداد وام ضامن شده:</small>
							<div class="pointer" @click="dialogThirdPersonAssurance = true">
								<v-badge color="#bbb" :content="String(localData.thirdPersonAssuranceCount)" inline>
								</v-badge>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="modify-member-actions__buttons d-flex flex-wrap justify-center justify-md-end">
				<v-btn class="ma-1 flex-grow-1 flex-md-grow-0" @click="$emit('callbck', false)">
					بستن
				</v-btn>
				<v-btn class="ma-1 flex-grow-1 flex-md-grow-0" color="blue" dark :loading="loading" @click="submit">
					ذخیره
				</v-btn>
			</div>
		</v-card-actions>

		<v-dialog v-model="dialogThirdPersonAssurance" scrollable persistent max-width="600px">
			<v-card color="#eee">
				<v-card-title>
					<span class="headline"></span>
					<v-spacer />
					<v-btn @click="dialogThirdPersonAssurance = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ThirdPersonAssurancesWidget v-if="dialogThirdPersonAssurance" area="admin" :memberId="localData.id" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogThirdParty" scrollable persistent>
			<v-card>
				<v-card-title>
					<span class="headline">ارتباط با دیگر نرم افزارها</span>
					<v-spacer />
					<v-btn @click="dialogThirdParty = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<thirdParty v-if="dialogThirdParty" @callbck="callbck_thirdParty" :entityType="'User'" :entityId="localData.id.toString()" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="iceDialog" max-width="800px">
			<v-card>
				<v-card-title>
					<div><span class="headline">اعتبارسنجی ها</span></div>
					<v-spacer />
					<v-btn @click="iceDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<IceManager :isAdmin="true" v-if="iceDialog" :userId="localData.id" :isSummery="false" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="iranValidityDialog" max-width="800px">
			<v-card>
				<v-card-title>
					<div><span class="headline">اعتبارسنجی ها</span></div>
					<v-spacer />
					<v-btn @click="iranValidityDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<IranValidityManager :isAdmin="true" v-if="iranValidityDialog" :userId="localData.id" :isSummery="false" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogOnlineGatewayPayments" scrollable max-width="1100px">
			<v-card>
				<v-card-title>
					<div><span class="headline">تراکنش های پرداخت آنلاین</span></div>
					<v-spacer />
					<v-btn @click="dialogOnlineGatewayPayments = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text style="height: 600px;">
					<v-container fluid>
						<online-gateway-payments ref="onlineGatewayPayments" v-if="dialogOnlineGatewayPayments" :data="{ memberId: this.data.id }" />
					</v-container>
				</v-card-text>

			</v-card>
		</v-dialog>

		<v-dialog v-model="manualWithdrawCreditDialog" max-width="500px">
			<v-form ref="formManualWithdrawCredit" lazy-validation @submit.prevent="submitManualWithdrawCredit">
				<v-card>
					<v-card-title>
						<div><span class="headline">واریز/برداشت از کیف پول</span></div>
						<v-spacer />
						<v-btn @click="manualWithdrawCreditDialog = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<div class="pa-8 pb-2 text-center mb-5" style="border-bottom: 1px dashed #ccc;">
								<div class="mb-2">اعتبار جاری</div>
								<div style="font-size:22px">{{ String(localData.credit).toPriceFormat() }} تومان</div>
							</div>
							<div class="text-center">
								<v-btn-toggle v-model="trsType" tile color="deep-purple accent-3" group>
									<v-btn :value="3" color="secondary" outlined class="mx-1 rounded-lg">
										واریز
									</v-btn>
									<v-btn :value="2" color="secondary" outlined class="mx-1 rounded-lg">
										برداشت
									</v-btn>
								</v-btn-toggle>
							</div>
							<div>
								<v-text-money class="align-center" v-model="trsAmount" label="مبلغ (تومان)" :error-messages="errorMessages" :rules="[(val) => trsAmount > 0 || 'مبلغ را به صورت صحیح وارد کنید', (val) => trsType === 3 || trsAmount <= Number(localData.credit) || 'مبلغ وارد شده بیشتر از اعتبار کیف پول است']" required />
							</div>
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn @click="manualWithdrawCreditDialog = false">
							بستن
						</v-btn>
						<v-btn color="blue" type="submit" dark :loading="submitManualWithdrawCreditLoading">
							ذخیره
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<v-dialog v-model="inquiriesDialog" max-width="500px">
			<v-card>
				<v-card-title>
					<div><span class="headline">استعلام ها - {{ localData.firstName }} {{ localData.lastName }}</span>
					</div>
					<v-spacer />
					<v-btn @click="inquiriesDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<inquiries v-if="inquiriesDialog" :userId="localData.id" :userInfo="localData" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />

	</v-card>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { call, get } from 'vuex-pathify'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
	import ReliabilityManager from '@/components/ReliabilityManager'
	import MemberAuthorizationManager from '@/components/memberAuthorization/MemberAuthorizationManager'
	import ThirdPersonAssurancesWidget from '@/components/ThirdPersonAssurancesWidget.vue'

	export default {
		name: 'ModifyMember',
		components: {
			Countdown: () => import('@/components/Countdown'),
			IranValidityManager: () => import('@/components/loanAuthorizations/IranValidityManager'),
			ReliabilityManager: ReliabilityManager,
			MemberAuthorizationManager: MemberAuthorizationManager,
			ThirdPersonAssurancesWidget,
			'thirdParty': () => import('@/views/admin/ThirdParty.vue'),
			'date-picker': VuePersianDatetimePicker,
			'app-sms-detail': () => import('@/components/AppSmsDetails.vue'),
			'online-gateway-payments': () => import('./Report/OnlineGatewayPayments.vue'),
			'inquiries': () => import('@/components/UserInquiryHistory.vue'),
		},
		props: {
			data: { type: Object },
		},
		data() {
			return {
				iceDialog: false,
				dialogThirdPersonAssurance: false,
				iranValidityDialog: false,
				inquiriesDialog: false,
				errorMessages: '',
				localData: {},
				selectAgentMode: false,
				loadingAgents: false,
				datePickerValidatioin: '',
				birthDatePickerValidatioin: '',
				agents: [],
				loading: false,
				bankAccounts: [],
				dialogOnlineGatewayPayments: false,
				dialogThirdParty: false,
				manualWithdrawCreditDialog: false,
				submitManualWithdrawCreditLoading: false,
				trsType: 3,
				trsAmount: 0,
				optLoading: false,
				sendCodeVisible: true,
				initMobile: ''
			}
		},
		mounted() {
			this.prepareData()
		},
		computed: {
			...get('appSettings', [
				'settings',
			]),
			isSuperAdmin: get('auth/isSuperAdmin')
		},
		methods: {
			countDownFinished() {
				this.sendCodeVisible = true
			},
			sendOTP() {
				if (!this.localData.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendOTP/' + this.localData.mobile, {})
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
			setSelectAgentMode() {
				this.selectAgentMode = true
			},
			loadAgents() {
				this.loadingAgents = true
				api.get('admin/agent/ListLight', null)
					.then(response => {
						this.agents = response.filter(x => !x.agentId)
						this.selectAgentMode = true
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loadingAgents = false })
			},
			showIce() {
				this.iceDialog = true
			},
			showIranValidity() {
				this.iranValidityDialog = true
			},
			async submit() {
				this.datePickerValidatioin = ''
				this.birthDatePickerValidatioin = ''
				if (this.localData.regDate2 === '') {
					this.datePickerValidatioin = 'تاریخ را وارد کنید'
					return
				}
				if (!this.localData.birthDate) {
					this.birthDatePickerValidatioin = 'تاریخ تولد را وارد کنید'
					return
				}
				if (!this.$refs.form.validate() || this.birthDatePickerValidatioin || this.datePickerValidatioin) {
					toast.error('ابتدا تمام بخش های فرم را تکمیل نمایید.')
					return
				}
				let data = {}
				data = Object.assign(data, this.localData)
				let confirmSms = false
				if (this.localData.id === 0 && this.settings.registerSmsPattern) {
					confirmSms = await this.$refs.confirm.open(
						'توجه',
						'آیا مایل به ارسال پیامک خوش آمد ثبت نام به مشتری هستید؟',
					)
				}
				data.sendSms = !!confirmSms
				data.bankAccountsJson = JSON.stringify(this.bankAccounts)
				this.loading = true
				api.post('admin/member/' + (this.localData.id === 0 ? 'create' : 'edit'), data)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.$emit('callbck', true)
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: 0 }
				}
				if (!this.data.id) {
					this.data.id = 0
				}
				api.get('admin/member/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							if (this.data.id === 0) Object.assign(this.localData, this.data)
							if (this.localData.regDate2 === '0001-01-01T00:00:00') { this.localData.regDate2 = '' }
							this.bankAccounts = this.localData.bankAccountsJson ? JSON.parse(this.localData.bankAccountsJson) : []
							this.initMobile = this.localData.mobile
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			removeBankAccount(item, index) {
				this.bankAccounts.splice(index, 1)
			},
			addBankAccount() {
				let newItem = {
					accountNumber: '',
					bank: '',
					branch: '',
				}
				this.bankAccounts.push(newItem)
			},
			creditChargeTransactions() {
				this.dialogOnlineGatewayPayments = true
			},
			manualWithdrawCredit() {
				if (!this.checkPermission('ManualWalletTransaction')) {
					toast.error('دسترسی به این بخش برای شما مجاز نمی باشد.')
					return
				}

				this.trsAmount = 0
				this.manualWithdrawCreditDialog = true
			},
			submitManualWithdrawCredit() {
				if (!this.$refs.formManualWithdrawCredit.validate()) { return }
				let data = {
					memberId: this.localData.id,
					amount: this.trsAmount,
					type: this.trsType
				}
				this.submitManualWithdrawCreditLoading = true
				api.post('admin/MemberPurchase/SubmitManualWalletTransaction', data)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.prepareData()
						this.manualWithdrawCreditDialog = false
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.submitManualWithdrawCreditLoading = false
					})
			},
			manageWalletLock() {
				api.post(`admin/Member/ManageWalletLock?id=${this.localData.id}&isLock=${!this.localData.walletIsLock}`, {})
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						this.localData.walletIsLock = !this.localData.walletIsLock
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {

					})
			},
			callbck_thirdParty() {
				this.dialogThirdParty = false
			},
			isEmailValid() {
				return this.localData.email &&
					/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/g.test(this.localData.email)
			},
		},
	}
</script>
<style scoped>
.modify-member-actions {
	background-color: #eee;
}

.modify-member-actions__main {
	min-width: 0;
	width: 100%;
}

.modify-member-actions__meta {
	padding: 8px 4px;
}

.modify-member-actions__wallet {
	border-bottom: 1px dashed #ddd;
	margin-bottom: 8px;
	padding-bottom: 8px;
}

.modify-member-actions__link {
	font-size: 12px;
	padding: 0 5px;
	white-space: nowrap;
}

.modify-member-actions__buttons {
	width: 100%;
	flex: 0 0 auto;
}

@media (min-width: 960px) {
	.modify-member-actions__main {
		width: auto;
	}

	.modify-member-actions__buttons {
		width: auto;
		min-width: 200px;
	}
}
</style>
